<template>
  <aside class="aside-menu" :class="{ open: value }" v-click-outside="close">
    <div class="ml-3 mt-4" @click="home">
      <img :src="require(`@/assets/images/logo-${$setup.theme}.svg`)" alt="" />
    </div>

    <div
      class="btn-close d-flex align-items-center justify-content-center"
      @click="close"
    >
      <i class="icon-chevron-left" />
    </div>

    <div class="menu-items flex-fill mt-5">
      <menu-item
        v-for="(module, i) in modules"
        :key="i"
        class="mb-2"
        :module="module"
        :selectedItem="selectedItem"
        @selectItem="selectItem"
        @close="close"
      />
    </div>

    <user-progress class="mx-2 mb-2 mt-4" />

    <div v-if="socialMediaUrl.length" class="pt-3 mb-3" :class="`social-media`">
      <div class="divider mb-3" />
      <div class="ml-3">
        <div class="mb-2">
          {{ this.socialMediaUrl.length > 1 ? "Redes Sociais" : "Rede Social" }}
        </div>
        <a
          v-for="(url, i) in $setup.setup.social_media"
          v-show="url"
          :key="i"
          :class="`icon-${i} mr-3`"
          :href="url.includes('https://') ? url : `https://${url}`"
          target="_blank"
        />
      </div>
    </div>
  </aside>
</template>

<script>
import MenuItem from "@/components/MenuItem.vue";
import UserProgress from "@/components/UserProgress.vue";
import ClickOutside from "vue-click-outside";
import { mapState } from "vuex";

export default {
  directives: {
    ClickOutside
  },
  components: { UserProgress, MenuItem },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedItem: ""
    };
  },
  computed: {
    ...mapState("modules", ["modules"]),
    socialMediaUrl() {
      if (this.$setup.setup.social_media !== null) {
        return Object.values(this.$setup.setup.social_media).filter(
          item => item != ""
        );
      } else return [];
    }
  },
  methods: {
    selectItem(item) {
      if (item.id == this.selectedItem) {
        this.selectedItem = "";
      } else {
        this.selectedItem = item.id;
      }
    },
    home() {
      this.$emit("close");
      this.$router.push({ name: "home" });
    },
    close() {
      this.$emit("close");
    }
  },
  watch: {
    value(val) {
      if (val == false) {
        this.selectedItem = "";
      }
    }
  }
};
</script>

<style lang="scss">
.aside-menu {
  top: 0;
  left: -328px;
  width: 314px;
  bottom: 0;
  z-index: 8;
  display: flex;
  position: fixed;
  transition: all 0.3s;
  flex-direction: column;

  .menu-items {
    overflow: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .btn-close {
    top: 28px;
    width: 28px;
    left: 300px;
    height: 28px;
    cursor: pointer;
    position: absolute;
    border-radius: 100%;
    i {
      font-size: 18px;
    }
  }

  &::-webkit-scrollbar {
    display: none;
  }

  &.open {
    left: 0;
    .btn-lock {
      display: flex;
    }
  }
}
</style>
